import { type ComponentType } from 'react'
import { useIntl } from 'react-intl'

import { getMeaIcon, type MeaIcon } from '@DS/components/icons/meaIcons'
import { type TranslationMessagesKeys } from '@Types/lang'
import { type SeverityType } from '@Types/severity'

type UseSeverityIconReturn = {
  icon: ComponentType | undefined
  ariaLabel: string | undefined
}

// TODO IVTS-30067: Remove côté back les info et info_action, et alléger ce Record.
const ICONS: Record<SeverityType, MeaIcon> = {
  alert: 'alert',
  delay: 'delay',
  info: 'info',
  info_message: 'info_message',
  info_action: 'info_action',
  positive: 'positive',
  roadworks: 'roadworks',
  service: 'info',
  train_delete: 'train_delete',
  warning: 'warning',
  warning_red: 'warning_red',
}

// TODO IVTS-30067: Remove côté back les info et info_action, et alléger ce Record.
const ARIA_LABELS: Record<SeverityType, keyof TranslationMessagesKeys> = {
  alert: 'accessibility_meaIcon_alert',
  delay: 'accessibility_meaIcon_delay',
  info: 'accessibility_meaIcon_info',
  info_message: 'accessibility_meaIcon_info',
  info_action: 'accessibility_meaIcon_info',
  positive: 'accessibility_meaIcon_positive',
  roadworks: 'accessibility_meaIcon_roadworks',
  service: 'accessibility_meaIcon_info',
  train_delete: 'accessibility_meaIcon_train_delete',
  warning: 'accessibility_meaIcon_warning',
  warning_red: 'accessibility_meaIcon_warning',
}

export const useSeverityIcon = (severity?: SeverityType): UseSeverityIconReturn => {
  const { formatMessage } = useIntl()

  const isExistingSeverity = !!(severity && ARIA_LABELS[severity])

  if (!isExistingSeverity) {
    return {
      icon: getMeaIcon(ICONS.info_message),
      ariaLabel: formatMessage({ id: ARIA_LABELS.info_message }),
    }
  }

  return {
    icon: getMeaIcon(ICONS[severity]),
    ariaLabel: formatMessage({ id: ARIA_LABELS[severity] }),
  }
}
